/**
 * Trigger a browser download of in-memory text (CSV exports etc.).
 */
export function downloadTextFile(
  text: string,
  filename: string,
  mimeType: string,
): void {
  const url = URL.createObjectURL(new Blob([text], { type: mimeType }))
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  // In the DOM before the click and revoked on a later tick: Chromium
  // tolerates a detached anchor and a same-tick revoke, Firefox historically
  // does not, and a revoked blob can abort the download mid-flight.
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => { URL.revokeObjectURL(url) }, 0)
}
